import { createAction, props } from '@ngrx/store';
import { Post } from '@planone/bau365/util-fair-data';

export const postOpened = createAction('[Post Page] Opened', props<{ postId: string; fairId?: string }>());

export const postLoadSucceeded = createAction('[Post API] Post load succeeded', props<{ post: Post }>());
export const postLoadFailed = createAction('[Post API] Post load failed', props<{ error: string }>());
